import { render } from "./ObjectSearchResult.vue?vue&type=template&id=0235481c"
import script from "./ObjectSearchResult.vue?vue&type=script&lang=js"
export * from "./ObjectSearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__